/* ---------------------------------------------------------------------------
   gift-tag-mode.js  —  Called to More                            v4
   Add-ons for the custom gift box builder.  Three jobs:

     1. GIFT TAG MODE — a card-collection product tagged `gift-tag` gets
        To / From only; the printed-message box and "Leave blank" checkbox are
        hidden.  The `gift-tag` tag is all such a product needs.

     2. CART FAILURE SAFETY NET — if the add-to-cart call fails for any reason
        (something sold out mid-session, a network hiccup), the shopper sees a
        real message instead of a button that silently does nothing.

     3. UPLOAD RACE GUARD — an item cannot be added to the box until its photos
        have actually finished uploading, and the shopper is told why they are
        waiting instead of clicking a dead button.

   Deliberately additive — this file does not modify custom.js,
   mother-gift-box.liquid, or any other existing theme file.  Delete this file
   and its one <script> line and the theme is byte-for-byte back to normal.

   (The filename is now narrower than what the file does — worth renaming to
   something like gift-box-extras.js next time the <script> line is touched.)

   TWO PIECES OF THEME BEHAVIOUR THIS FILE WORKS AROUND
   ----------------------------------------------------
   1. The button branch.  The card grid renders `<button class="customize-card">`
      only for products carrying the "Gift Card" tag; everything else gets
      `<button class="add-to-cart">`, and NOTHING in custom.js listens for that
      class inside .gift-cards — so the button is inert.  Rather than making you
      remember a second tag on every tag product, we wire that button up
      ourselves, mirroring exactly what the theme's own handler does.

   2. The print_msg gotcha.  custom.js only attaches To and From as cart
      line-item properties when the printed message is non-empty:

          print_msg ? {properties: {"Print Message", To, From}} : {id, quantity}

      An empty message would silently drop the recipient names from the order.
      So we write a fixed placeholder into the (hidden) textarea, which keeps
      To/From flowing and reads clearly on the order.
--------------------------------------------------------------------------- */

(function () {
  'use strict';

  /* --------------------------- Editable copy --------------------------- */

  // The product tag that turns a card into a gift tag.
  var GIFT_TAG = 'gift-tag';

  // Recorded as the "Print Message" property for a gift tag.
  // Change freely — this is what you see on the order.
  var PLACEHOLDER_MESSAGE = 'Gift tag — no printed message (To/From only)';

  // Shown if the cart call fails. Change freely.
  var CART_ERROR_TITLE = 'One of your choices just sold out';
  var CART_ERROR_BODY  = 'Sorry — one of the items in your box is no longer ' +
                         'available, so we could not add it to your cart. Please go ' +
                         'back and pick a different option, then try again.';
  var CART_ERROR_DISMISS = 'OK';

  /* --------------------------------------------------------------------- */

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  onReady(function () {
    var cardsStep = document.querySelector('.gift-cards');
    if (!cardsStep) { return; }   // not a gift box product page — do nothing

    /* -- 1. Styles ------------------------------------------------------- */
    var style = document.createElement('style');
    style.setAttribute('data-gift-tag-mode', '');
    style.textContent =
      '.gift-card-change.is-gift-tag .textarea-wrap,' +
      '.gift-card-change.is-gift-tag .checkbox-wrap { display: none !important; }' +
      '.gift-cart-error { margin: 16px 0 0; padding: 14px 16px; border: 1px solid #b3261e;' +
      '  background: #fdf4f3; color: #4a1512; font-size: 14px; line-height: 1.5; }' +
      '.gift-cart-error strong { display: block; margin-bottom: 4px; font-size: 15px; }' +
      '.gift-cart-error button { margin-top: 10px; }' +
      '.gift-upload-hint { margin: 8px 0 0; font-size: 13px; line-height: 1.4; color: #848c8a; }';
    document.head.appendChild(style);

    /* -- 2. Flag which card items are gift tags -------------------------- */
    /* Each card renders a quick-view element carrying data-product-handle, so
       we can ask Shopify for that product's tags.                           */
    var items = cardsStep.querySelectorAll('.gift-product-item');

    Array.prototype.forEach.call(items, function (item) {
      var handleEl = item.querySelector('[data-product-handle]');
      if (!handleEl) { return; }

      var handle = handleEl.getAttribute('data-product-handle');
      if (!handle) { return; }

      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product || !product.tags) { return; }
          var isTag = product.tags.some(function (t) {
            return String(t).trim().toLowerCase() === GIFT_TAG;
          });
          if (isTag) { item.setAttribute('data-card-type', 'tag'); }
        })
        .catch(function () { /* offline / blocked — card just behaves normally */ });
    });

    /* -- 3. Self-wiring: replicate the theme's card selection ------------ */
    /* Mirrors custom.js's own `.gift-cards .customize-card` handler, so a tag
       product works without needing the "Gift Card" tag.  Only ever runs for
       items we have positively identified as gift tags — a normal card with an
       inert button is left exactly as the theme rendered it.                */
    function selectCard(item) {
      var titleEl = item.querySelector('.product-title');
      var imageEl = item.querySelector('.product-image');
      var priceEl = item.querySelector('.product-price');
      var variantEl = item.querySelector('.gift-variant-id');

      var cardTitle = document.querySelector('.card-image-wrap .card-title');
      var cardImage = document.querySelector('.card-image-wrap .card-image');
      var cardId    = document.querySelector('.gift-card-change .change-card-id');
      var panel     = document.querySelector('.gift-customize-content .gift-cards');

      if (cardTitle && titleEl) { cardTitle.textContent = titleEl.textContent; }
      if (cardImage && imageEl) { cardImage.setAttribute('src', imageEl.getAttribute('src')); }
      if (cardId) {
        if (variantEl) { cardId.value = variantEl.value; }
        cardId.setAttribute('data-price', priceEl ? (priceEl.getAttribute('data-price') || '0') : '0');
      }
      if (panel) { panel.classList.add('open-customizer'); }
    }

    /* -- 4. Switch the shared form in and out of tag mode ---------------- */
    /* .gift-card-change is rendered once and reused for whichever card was
       clicked, so we react to the same click the theme reacts to.           */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') { return; }

      var trigger = target.closest('.gift-cards .cta-wrap button');
      if (!trigger) { return; }

      var item = trigger.closest('.gift-product-item');
      var form = document.querySelector('.gift-card-change');
      if (!item || !form) { return; }

      var isGiftTag  = item.getAttribute('data-card-type') === 'tag';
      var themeWired = trigger.classList.contains('customize-card');

      // A non-tag card whose button the theme did not wire up is not ours to
      // fix — leave it alone rather than inventing behaviour.
      if (!themeWired && !isGiftTag) { return; }

      // The theme handles selection for its own buttons; we handle it for the
      // inert ones so a `gift-tag` product needs no second tag.
      if (!themeWired) { selectCard(item); }

      var textarea   = form.querySelector('.card-print-message');
      var leaveBlank = document.getElementById('leave-print-message');
      if (!textarea) { return; }

      form.classList.toggle('is-gift-tag', isGiftTag);

      if (isGiftTag) {
        // Keep the theme's own "write their own message" branch switched off.
        if (leaveBlank) { leaveBlank.checked = false; }
        textarea.value = PLACEHOLDER_MESSAGE;
      } else if (textarea.value === PLACEHOLDER_MESSAGE) {
        // They backed out of a tag and picked a real card — start clean.
        textarea.value = '';
      }
    }, false);

    /* -- 5. Cart failure safety net -------------------------------------- */
    /* custom.js posts to /cart/clear.js and then /cart/add.js with no error
       handler and no redirect on failure, so a rejected line item leaves the
       shopper on the page with an emptied cart and a button that appears to do
       nothing.  jQuery fires a global ajaxError for exactly this, which lets us
       respond without touching custom.js.                                    */
    function showCartError(detail) {
      var ctaWrap = document.querySelector('.gift-card-change .cta-wrap');
      if (!ctaWrap) { return; }

      // The theme leaves the button in its loading state when the call fails.
      var button = ctaWrap.querySelector('.add-to-cart');
      if (button) { button.classList.remove('loading'); }

      var existing = ctaWrap.querySelector('.gift-cart-error');
      if (existing) { existing.remove(); }

      var box = document.createElement('div');
      box.className = 'gift-cart-error';
      box.setAttribute('role', 'alert');

      var title = document.createElement('strong');
      title.textContent = CART_ERROR_TITLE;

      var body = document.createElement('span');
      body.textContent = CART_ERROR_BODY;

      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'button';
      dismiss.textContent = CART_ERROR_DISMISS;
      dismiss.addEventListener('click', function () { box.remove(); });

      box.appendChild(title);
      box.appendChild(body);
      box.appendChild(dismiss);
      ctaWrap.appendChild(box);
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });

      // Technical detail stays out of the shopper's way but is there for you.
      if (window.console && console.warn) {
        console.warn('[gift box] add to cart failed:', detail);
      }
    }

    /* -- 6. Upload race guard -------------------------------------------- */
    /* custom.js enables the "Add To Gift Box" button as soon as the right NUMBER
       of files has been SELECTED:

           widget.onChange(function (group) {
             if (group.files().length == widget.inputElement.dataset.multipleMax)
               ...classList.remove("disabled");

       But the input's value — the Uploadcare group URL — is not written until
       the upload actually finishes. Its click handler reads that value:

           uploads = giftItem.find(".gift-uploads").val();
           if ($this.hasClass("disabled")) { return; }

       So between "6 files chosen" and "6 files uploaded" the button is live and
       `uploads` is an empty string. Clicking there adds the item with NO photos
       attached, and the order completes anyway — confirmed on order #1001.

       We re-apply the theme's own `disabled` class whenever the value is empty.
       Its handler already bails out on that class, so the fix needs no changes
       to custom.js and does not depend on handler ordering. */
    var HINT_UPLOADING = 'Your photos are still uploading — this button turns on when they finish.';
    var HINT_NO_PHOTOS = 'Please choose your photos first.';

    function hintFor(ctaWrap, message) {
      var hint = ctaWrap.querySelector('.gift-upload-hint');
      if (!message) { if (hint) { hint.remove(); } return; }
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'gift-upload-hint';
        ctaWrap.appendChild(hint);
      }
      hint.textContent = message;
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.customize-items .gift-uploads'),
      function (input) {
        var ctaWrap = input.closest('.cta-wrap');
        var button = ctaWrap && ctaWrap.querySelector('.add-to-cart');
        if (!button) { return; }

        var weDisabledIt = false;

        function sync() {
          // Once added, the theme owns the button — leave it alone.
          if (button.textContent.trim() === 'ADDED') { return; }

          var ready = !!(input.value && input.value.trim());

          if (!ready && !button.classList.contains('disabled')) {
            button.classList.add('disabled');
            weDisabledIt = true;
            hintFor(ctaWrap, HINT_UPLOADING);
          } else if (ready && weDisabledIt) {
            button.classList.remove('disabled');
            weDisabledIt = false;
            hintFor(ctaWrap, null);
          }
        }

        sync();
        setInterval(sync, 300);
      }
    );

    /* -- 7. Say something when a disabled button is clicked --------------- */
    /* The theme's own "please upload a file" popup is commented out, so a
       disabled button is completely silent. Its handler returns early, so this
       listener still runs and can explain the wait. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') { return; }

      var button = target.closest('.customize-items .add-to-cart.disabled');
      if (!button) { return; }

      var ctaWrap = button.closest('.cta-wrap');
      var input = ctaWrap && ctaWrap.querySelector('.gift-uploads');
      if (!ctaWrap || !input) { return; }

      hintFor(ctaWrap, input.value && input.value.trim() ? HINT_UPLOADING : HINT_NO_PHOTOS);
    }, false);

    if (window.jQuery) {
      window.jQuery(document).ajaxError(function (event, jqxhr, settings) {
        if (!settings || typeof settings.url !== 'string') { return; }
        if (settings.url.indexOf('/cart/add') === -1) { return; }
        showCartError((jqxhr && jqxhr.responseJSON) || (jqxhr && jqxhr.status) || 'unknown');
      });
    }
  });
})();